export default __webpack_public_path__ + "static/media/controlled-chair.e328f396.png";